
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { AccountingPlanStatus } from 'enums/AccountingPlanStatus';
import { AccountingPlanSetupModel } from './Entities.Accounting.AccountingPlanSetup';
import { LedgerPostModel } from './Entities.Accounting.LedgerPost';
import { RevenueRegistrationModel } from './Entities.Accounting.RevenueRegistration';
import { Model, ModelProperty } from 'models/Model';


export class AccountingPlanModel extends Model<AccountingPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'status', type: 'AccountingPlanStatus', languageString: 'accountingPlan.property.status' },
		{ name: 'systemStart', type: 'Date', languageString: 'accountingPlan.property.systemStart' },
		{ name: 'systemEnd', type: 'Date', languageString: 'accountingPlan.property.systemEnd' },
		{ name: 'totalPlanValue', type: 'number', languageString: 'accountingPlan.property.totalPlanValue' },
		{ name: 'id', type: 'guid', languageString: 'accountingPlan.property.id', isHidden: true },
		{ name: 'productPlanId', type: 'guid', languageString: 'accountingPlan.property.productPlanId' },
		{ name: 'startUpDeliveryDate', type: 'Date', languageString: 'accountingPlan.property.startUpDeliveryDate' },
		{ name: 'startDate', type: 'Date', languageString: 'accountingPlan.property.startDate' },
		{ name: 'endDate', type: 'Date', languageString: 'accountingPlan.property.endDate' },
		{ name: 'paymentInterval', type: 'number', languageString: 'accountingPlan.property.paymentInterval' },
		{ name: 'accountingPlanSetupId', type: 'guid', languageString: 'accountingPlan.property.accountingPlanSetupId' },
		{ name: 'salesTypeDimension', type: 'string', languageString: 'accountingPlan.property.salesTypeDimension' },
		{ name: 'departmentDimension', type: 'string', languageString: 'accountingPlan.property.departmentDimension' },
		{ name: 'companyDimension', type: 'string', languageString: 'accountingPlan.property.companyDimension' },
		{ name: 'startupAmount', type: 'number', languageString: 'accountingPlan.property.startupAmount' },
		{ name: 'startupInstallments', type: 'number', languageString: 'accountingPlan.property.startupInstallments' },
		{ name: 'pausedRegistrations', type: 'Date', languageString: 'accountingPlan.property.pausedRegistrations' },
		{ name: 'completedRegistrations', type: 'Date', languageString: 'accountingPlan.property.completedRegistrations' },
		{ name: 'subscriptionNo', type: 'string', languageString: 'accountingPlan.property.subscriptionNo' },
		{ name: 'suspended', type: 'Date', languageString: 'accountingPlan.property.suspended' },
		{ name: 'systemConverted', type: 'boolean', languageString: 'accountingPlan.property.systemConverted' },
		{ name: 'supersedesAccountingPlanId', type: 'guid', languageString: 'accountingPlan.property.supersedesAccountingPlanId' },
		{ name: 'ignorePriceAdjustments', type: 'boolean', languageString: 'accountingPlan.property.ignorePriceAdjustments' },
		{ name: 'referenceNo', type: 'number', languageString: 'accountingPlan.property.referenceNo' },
		{ name: 'latestAnnualPriceAdjustment', type: 'Date', languageString: 'accountingPlan.property.latestAnnualPriceAdjustment' },
		{ name: 'companyId', type: 'guid', languageString: 'accountingPlan.property.companyId' },
		{ name: 'generateInvoicesBasedOnProductPlanId', type: 'guid', languageString: 'accountingPlan.property.generateInvoicesBasedOnProductPlanId' },
		{ name: 'numberOfInstallments', type: 'number', languageString: 'accountingPlan.property.numberOfInstallments' },
		{ name: 'autoRenewedFromAccountingPlanId', type: 'guid', languageString: 'accountingPlan.property.autoRenewedFromAccountingPlanId' },
		{ name: 'deleted', type: 'boolean', languageString: 'accountingPlan.property.deleted', isHidden: true },
		{ name: 'brandId', type: 'guid', languageString: 'accountingPlan.property.brandId' },
		{ name: 'accountingPlanSetup', type: 'AccountingPlanSetupModel', languageString: 'accountingPlan.property.accountingPlanSetup', isHidden: true, isObject: true, new: () => { return new AccountingPlanSetupModel }, properties: () => { return AccountingPlanSetupModel.classProperties } },
		{ name: 'inverseSupersedesAccountingPlan', type: 'AccountingPlanModel[]', languageString: 'accountingPlan.property.inverseSupersedesAccountingPlan', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } },
		{ name: 'ledgerPosts', type: 'LedgerPostModel[]', languageString: 'accountingPlan.property.ledgerPosts', isHidden: true, isArray: true, isObject: true, new: () => { return new LedgerPostModel }, properties: () => { return LedgerPostModel.classProperties } },
		{ name: 'revenueRegistrations', type: 'RevenueRegistrationModel[]', languageString: 'accountingPlan.property.revenueRegistrations', isHidden: true, isArray: true, isObject: true, new: () => { return new RevenueRegistrationModel }, properties: () => { return RevenueRegistrationModel.classProperties } },
		{ name: 'supersedesAccountingPlan', type: 'AccountingPlanModel', languageString: 'accountingPlan.property.supersedesAccountingPlan', isHidden: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public status: AccountingPlanStatus;
	public systemStart?: Date;
	public systemEnd?: Date;
	public totalPlanValue: number;
	public id?: string;
	public productPlanId?: string;
	public startUpDeliveryDate?: Date;
	public startDate?: Date;
	public endDate?: Date;
	public paymentInterval?: number;
	public accountingPlanSetupId?: string;
	public salesTypeDimension: string;
	public departmentDimension: string;
	public companyDimension: string;
	public startupAmount?: number;
	public startupInstallments?: number;
	public pausedRegistrations?: Date;
	public completedRegistrations?: Date;
	public subscriptionNo: string;
	public suspended?: Date;
	public systemConverted?: boolean;
	public supersedesAccountingPlanId?: string;
	public ignorePriceAdjustments: boolean;
	public referenceNo: number;
	public latestAnnualPriceAdjustment?: Date;
	public companyId?: string;
	public generateInvoicesBasedOnProductPlanId?: string;
	public numberOfInstallments?: number;
	public autoRenewedFromAccountingPlanId?: string;
	public deleted: boolean;
	public brandId?: string;
	public accountingPlanSetup?: AccountingPlanSetupModel;
	public inverseSupersedesAccountingPlan: AccountingPlanModel[];
	public ledgerPosts: LedgerPostModel[];
	public revenueRegistrations: RevenueRegistrationModel[];
	public supersedesAccountingPlan?: AccountingPlanModel;
    
	constructor(){
		super();
		this.status = 0;
		this.systemStart = undefined;
		this.systemEnd = undefined;
		this.totalPlanValue = 0;
		this.id = undefined;
		this.productPlanId = undefined;
		this.startUpDeliveryDate = undefined;
		this.startDate = undefined;
		this.endDate = undefined;
		this.paymentInterval = undefined;
		this.accountingPlanSetupId = undefined;
		this.salesTypeDimension = '';
		this.departmentDimension = '';
		this.companyDimension = '';
		this.startupAmount = undefined;
		this.startupInstallments = undefined;
		this.pausedRegistrations = undefined;
		this.completedRegistrations = undefined;
		this.subscriptionNo = '';
		this.suspended = undefined;
		this.systemConverted = undefined;
		this.supersedesAccountingPlanId = undefined;
		this.ignorePriceAdjustments = false;
		this.referenceNo = 0;
		this.latestAnnualPriceAdjustment = undefined;
		this.companyId = undefined;
		this.generateInvoicesBasedOnProductPlanId = undefined;
		this.numberOfInstallments = undefined;
		this.autoRenewedFromAccountingPlanId = undefined;
		this.deleted = false;
		this.brandId = undefined;
		this.accountingPlanSetup = undefined;
		this.inverseSupersedesAccountingPlan = [];
		this.ledgerPosts = [];
		this.revenueRegistrations = [];
		this.supersedesAccountingPlan = undefined;
		
	}
	getProperties(){
		return AccountingPlanModel.classProperties;
	}
}

